import axios from '../../index'
export default {
    // CAPTURA DE CALIFICACIONES 
    getciclosEscolaresDocente() {
        return axios.get('/docente-calificaciones/get-ciclos-escolares-docentes')
    },
    getInstitucionDocente () {
        return axios.get('/docente-calificaciones/getInstitucionesDocente')
    },
    getProgramaDocentes(params) {
        return axios.get('/docente-calificaciones/getProgramasDocente', {params})
    },
    getPeriodosDocentes(params) {
        return axios.get('/docente-calificaciones/getPeriodosCicloEscolar', {params})
    },
    getModoCaptura(params){
        return axios.get('/docente-calificaciones/getModoCapturaPeriodo', {params})
    },
    getCodigoSesion(params){
        return axios.get('/docente-calificaciones/getCodigosSesionDocente', {params})
    },
    getGrupoAcademicoL(params){
        return axios.get('/docente-calificaciones/getGruposAcademicosPorLista', {params})
    },
    getGrupoAcademicoS(params){
        return axios.get('/docente-calificaciones/getGruposAcademicosPorSabana', {params})
    },
    // Se obtiene Sabana de docente
    getAlumnoSabana(params){
        return axios.get('/docente-calificaciones/getSabanaDocente', {params})
    },
    // Se obtiene lista de alumnos a calificar mas parametros de calificación
    getAlumnoLista(params){
        return axios.get('/docente-calificaciones/getAlumnosACalificar', {params})
    },
    postGuardarEvaluacionLista(payload){
        return axios.post('/docente-calificaciones/storeCalificacionesPorLista', payload)
    },
    postGuardarSabana(payload){
        return axios.post('/docente-calificaciones/storeCalificacionesPorSabana', payload)
    },
    getCalificacionesActa(params){
        return axios.get('/docente-calificaciones/getActaPeriodos', {params})
    },
    getGuardarClases(params){
        return axios.get('/docente-calificaciones/getGuardarNumeroClasesImpartidas', {params})
    },

    // CARGA DE MATERIAL
    getAlumnoListaMaterial(payload){
        return axios.post('/api/documentos-docentes/lista-alumnos', payload)
    },
    getMaterialGeneral(params){
        return axios.get('/api/documentos-docentes', {params})
    },
    postGuardarMaterial(payload){
        return axios.post('/api/documentos-docentes', payload)
    },
    getDocumentosDownload(id){
        return axios.get('/api/documentos-docentes/' + id)
    },
    deletedMaterial(id){
        return axios.delete('/api/documentos-docentes/' + id)
    },

    //OBSERVACIONES DOCENTE

    postGuardarObservaciones(params){
        return axios.post('/docente-observaciones/storeObservacionesPorSabana', params)
    },

    getInstitucionesObservaciones(){
        return axios.get('/docente-observaciones/getInstitucionDocente')
    },
    getciclosEscolaresObservaciones(institucion){
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/' + institucion)
    },
    getCampoFormativoObservaciones(params){
        return axios.get('/docente-observaciones/getCampoFormativoPorDocente', {params})
    },
    getPeriodosObservaciones(params){
        return axios.get('/docente-observaciones/getPeriodosPorCampoFormativo', {params})
    },
    getGrupoAcademicoObservaciones(params){
        return axios.get('/docente-observaciones/getGruposAcademicosPorCampoFormativo', {params})
    },
    getObsercaciones(params){
        return axios.get('/docente-observaciones/getObservacionesPorCampoInformativo', {params})
    },
    getAlumnosObservaciones(params){
        return axios.get('/docente-observaciones/getAlumnosPorCampoFormativo', {params})
    },
}